import { getAxiosInstance } from '@/services/axiosConfig';
import { RunCostResponse } from '../api.shared.types';
import { RecipeRunCostRequest } from './recipe-runs.api.types';

const axiosInstance = getAxiosInstance();

export const getRecipeRunCostApi = async ({ recipeId, body }: RecipeRunCostRequest) => {
  const res = await axiosInstance.post<RunCostResponse>(`/v1/recipe-runs/recipes/${recipeId}/cost`, body, {
    'axios-retry': { retries: 0 },
  });
  return res.data;
};
